/*
 * @Author: songyzh
 * @Date: 2020-07-27 23:07:41
 * @LastEditors: songyzh
 * @LastEditTime: 2020-07-28 00:09:31
 */
import AppLayout from './layout.vue';

export default AppLayout;
